export default __webpack_public_path__ + "static/media/meme.6643be17.png";